<template>
  <div class="product-item">
    <!-- Product Image Container -->
    <router-link
      :to="path"
      tag="a"
      class="image-container"
    >
      <!-- Product Image -->
      <div class="content-layer">
        <div class="product-tags">
          <div
            v-if="item.award_winner"
            class="special-tag"
          >
            <div class="tag-content">
              Award Winner
            </div>
          </div>
          <div
            v-if="lowStock(item.id)"
            class="low-stock-tag"
          >
            <div class="tag-content">
              Low Stock
            </div>
          </div>
          <div
            v-if="outOfStock(item.id)"
            class="out-of-stock-tag"
          >
            <div class="tag-content">
              Out of Stock
            </div>
          </div>
        </div>
        <div class="product-teaser-quick-view-container hidden-sm hidden-xs">
          <b-button
            class="quick-view"
            title="Quickview"
          >
            <span>
              View product
            </span>
          </b-button>
        </div>
      </div>
      <AImage
        :img="item.image"
        preset="wineproductteaser"
        contain
      />
    </router-link>

    <!-- Product Teaser -->
    <div class="description-container">
      <!--<div-->
      <!--v-if="item.brand"-->
      <!--class="product-brand">-->
      <!--{{ item.brand }}-->
      <!--</div>-->

      <!-- Product Title -->
      <h3 class="product-name">
        <router-link
          :to="path"
          tag="a"
        >
          {{ item.title }}
        </router-link>
      </h3>

      <!-- Product Price -->
      <div class="product-price-container">
        <div class="price">
          <ecommerce-product-price
            :item="priceCalcItem"
            :showrrprice="false"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'wine-product-grid-item-0001',
  filters: {
    deDash(string) {
      if (string) {
        return string.replace('_', ' ')
      }
    }
  },
  props: {
    item: {
      type: Object,
      required: true
    }
  },
  computed: {
    productStock() {
      return this.$store.getters['productCatalog/getProductStock']
    },
    lowStockThreshold() {
      return this.$store.getters['productCatalog/getLowStockThreshold']
    },
    path() {
      if (this.item.path.startsWith('/')) return this.item.path
      return `/${this.item.path}`
    },
    priceCalcItem: function() {
      return {
        ...this.item,
        ptype: this.item.ptype,
        taxonomy: this.item.discountGroup,
        type: this.item.node_type
      }
    }
  },
  methods: {
    lowStock(id) {
      if (typeof this.productStock[id] !== 'undefined' && (parseInt(this.productStock[id].stock) <= this.lowStockThreshold && parseInt(this.productStock[id].stock) > 0) && this.parseBoolean(this.productStock[id].manage_stock)) {
        return true
      }
      return false
    },
    outOfStock(id) {
      if (typeof this.productStock[id] !== 'undefined' && parseInt(this.productStock[id].stock) <= 0 && this.parseBoolean(this.productStock[id].manage_stock)) {
        return true
      }
      return false
    },
    parseBoolean(v) {
      if (typeof v === 'string' && ['true', 'on', 'yes'].includes(v.toLowerCase())) {
        return true
      }
      else if (typeof v === 'string' && v !== '' && v !== '0') {
        return true
      }
      else if (typeof v === 'number' && !isNaN(parseInt(v)) && parseInt(v) !== 0) {
        return true
      }
      else if (typeof v === 'boolean') {
        return v
      }
      return false
    }
  }
}
</script>

<style scoped lang="scss">
@import "~@scss/custom.scss";

.product-item {
  width: 100%;
  display: flex;
  flex-direction: column;

  .image-container {
    margin-bottom: 1.5em;
  }

  .description-container {
    text-align: center;
    white-space: wrap;
    display: flex;
    flex-direction: column;
    flex-grow: 1;

    .product-brand {
      font-size: 2em;
      font-weight: bold;
      margin: 2em 0 0 0;
    }

    h3.product-name {
      font-size: 1.2em;
      margin: .5em 0;
      word-break:break-all;
      word-break: break-word;

      a {
        color: var(--main-text-heading-color);
      }
    }

    .product-price-container {
      margin-top: auto;

     ::v-deep .price {
        span {
          font-size: 1.5em;
          color: var(--main-product-price-text-color);
        }

        label {
          display: none;
        }
      }
    }

    .product-description {
      font-size: 1.3em;
      padding: 2em 0;
    }

    .product-description-extra {
      font-size: 1.3em;
      padding: 1em 0 2em 0;
      font-weight: bold;
    }
  }

  .image-container {
    transition: var(--main-transition);
    position: relative;
    display: flex;
    .content-layer {
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      position: absolute;
      z-index: 2;
      overflow: hidden;
      .btn.quick-view {
        background-color:var(--main-link-color);
        border-color:var(--main-link-color);
        color:var(--main-text-overlay-color);
        opacity: 0;
        transition: transform .3s, opacity .3s;
        transform: translate(0, 100%);
        position: absolute;
        width: 100%;
        font-size: 1em;
        border-radius: 0px;
        margin: 0;
        left: 0;
        bottom: 0;
        z-index: 2;
      }

      .product-tags {
        position: absolute;
        top: .75em;
        left: .75em;
        z-index: 2;

        .special-tag {
          background: var(--main-award-badge-background-color);
          border-radius: 50%;
          width: 5em;
          height: 5em;
          text-align: center;
          display: flex;
          justify-content: center;
          align-items: center;
          font-size: .9em;

          .tag-content {
            font-size: .867em;
            color: var(--main-award-badge-text-color);
            text-transform: capitalize;
          }
        }
        .low-stock-tag {
          background: var(--main-low-stock-badge-background-color);
          border-radius: 50%;
          width: 5em;
          height: 5em;
          text-align: center;
          display: flex;
          justify-content: center;
          align-items: center;
          font-size: .9em;

          .tag-content {
            font-size: .867em;
            color: var(--main-low-stock-badge-text-color);
            text-transform: capitalize;
          }
        }
        .out-of-stock-tag {
          background: var(--main-oos-badge-background-color);
          border-radius: 50%;
          width: 5em;
          height: 5em;
          text-align: center;
          display: flex;
          justify-content: center;
          align-items: center;
          font-size: .9em;

          .tag-content {
            font-size: .867em;
            color: var(--main-oos-badge-text-color);
            text-transform: capitalize;
          }
        }
      }
      @include hover-focus {
        .btn.quick-view {
          opacity: 1;
          transform: translate(0, 0em);
        }
      }
    }

    .a-image {
      padding-top: var(--main-product-image-aspect-ratio, 100%);
      background: var(--main-product-image-background);
      box-shadow: var(--main-product-image-box-shadow);
    }
  }

}
.product-item {
  ::v-deep .image-container {
    .a-image {
      img {
        padding: 1.5em;
      }
    }
  }
}
</style>
